// Display formatters shared by the views. NUMERIC columns arrive from the API
// as strings; these format them for display and leave the raw value alone.

const moneyFmt = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
  maximumFractionDigits: 0,
});

/** £1,234,567, or an em dash when there's no value. */
export function money(v: string | number | null | undefined): string {
  if (v === null || v === undefined || v === '') return '—';
  const n = Number(v);
  return Number.isNaN(n) ? String(v) : moneyFmt.format(n);
}

/** The value as text, or an em dash when there's none. */
export function plain(v: string | number | null | undefined): string {
  return v === null || v === undefined || v === '' ? '—' : String(v);
}

const dateFmt = new Intl.DateTimeFormat('en-GB', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

/** "24 Oct 2026, 09:30", or an em dash for a missing or invalid date. */
export function datetime(v: string | null): string {
  if (!v) return '—';
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? '—' : dateFmt.format(d);
}
